/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import ImageIcon from '@material-ui/icons/Image';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DescriptionIcon from '@material-ui/icons/Description';

import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import ls from 'local-storage';
import moment from 'moment';
import PageLoader from '../../Layouts/PageLoader';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';

import './TaskManagement.css';
import '../Leaves/Leave.css';
import '../Attendance/Attendance.css';
import './job.css';
import TimelineInputField, { clampAndFormatTimeline, validateTimeline } from './TimelineInputField';
import WysiwygDescriptionEditor from './WysiwygDescriptionEditor';
import { isProjectActive } from '../../../utils/projectStatus';
import defaultAvatar from '../../../Images/person.jpg';
import { resolveImageUrl } from '../../../utils/imageUrl';

// Upload Icon matching user specification (Tray + Up Arrow)
const TrayUploadIcon = ({ size = 20, style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={style}
    >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
);

const CreateTask = (props) => {
    const initialStatus = (props.location && props.location.state && props.location.state.defaultStatus) || 'Pending';
    const initialProject = (props.location && props.location.state && props.location.state.defaultProject) || '';

    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [usersLoading, setUsersLoading] = useState(true);
    const [projectsLoading, setProjectsLoading] = useState(true);

    const [taskData, setTaskData] = useState({
        task: '',
        project_name: initialProject,
        member_ids: [],
        timeline: '',
        task_date_time: moment().format('HH:mm'),
        task_deliver_date: '',
        description: '',
        status: initialStatus,
        priority: 'Medium',
    });

    const [developers, setDevelopers] = useState([]);
    const [projects, setProjects] = useState([]);

    // Subtasks State
    const [subTasks, setSubTasks] = useState([]);
    const [newSubTaskTitle, setNewSubTaskTitle] = useState('');
    const [newSubTaskStatus, setNewSubTaskStatus] = useState('Pending');
    const [newSubTaskTimeline, setNewSubTaskTimeline] = useState('');

    // Inline edit state for subtasks
    const [editingIndex, setEditingIndex] = useState(null);
    const [editSubTaskTitle, setEditSubTaskTitle] = useState('');
    const [editSubTaskStatus, setEditSubTaskStatus] = useState('Pending');
    const [editSubTaskTimeline, setEditSubTaskTimeline] = useState('');

    // File attachments state
    const [taskFiles, setTaskFiles] = useState([]);
    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const selected = Array.from(e.target.files || []);
        if (selected.length > 0) {
            setTaskFiles((prev) => [...prev, ...selected]);
        }
        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to remove this file?",
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        }).then((confirm) => {
            if (confirm) {
                setTaskFiles((prev) => prev.filter((_, i) => i !== index));
            }
        });
    };





    // User selector popover state (Attendance module style)
    const [userPopoverAnchor, setUserPopoverAnchor] = useState(null);
    const [userSearchQuery, setUserSearchQuery] = useState('');
    const avatarsScrollRef = useRef(null);

    useEffect(() => {
        const el = avatarsScrollRef.current;
        if (!el) return;

        const handleWheel = (e) => {
            const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
            if (delta !== 0) {
                e.preventDefault();
                e.stopPropagation();
                el.scrollBy({ left: Math.sign(delta) * 44, behavior: 'smooth' });
            }
        };

        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            el.removeEventListener('wheel', handleWheel);
        };
    }, [taskData.member_ids]);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                await Promise.all([fetchDevelopers(), fetchProjects()]);
            } finally {
                // individual loading states handle their own flags
            }
        };
        loadInitialData();
    }, []);

    const fetchDevelopers = async () => {
        try {
            setUsersLoading(true);
            const response = await AuthApi.getData();
            if (response && response.data) {
                const loggedUsers = response.data.filter((user) => Number(user.user_logged) === 1);
                setDevelopers(loggedUsers);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setUsersLoading(false);
        }
    };

    const extractIds = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw
                .map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item))
                .map(Number)
                .filter((id) => !isNaN(id));
        }
        if (typeof raw === 'string') {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    return parsed
                        .map((item) => (typeof item === 'object' && item !== null ? (item.id || item.user_id) : item))
                        .map(Number)
                        .filter((id) => !isNaN(id));
                }
            } catch (_) {
                return raw.split(',').map(Number).filter((id) => !isNaN(id));
            }
        }
        if (typeof raw === 'number') {
            return [raw];
        }
        return [];
    };

    const isUserSuperAdmin = () => {
        try {
            const roles = ls.get('roles') || ls('roles') || (props.authUser && props.authUser.roles);
            const role = ls.get('role') || ls('role') || (props.authUser && props.authUser.role);
            const adminRoles = ['super admin', 'admin', 'administrator'];
            if (typeof role === 'string' && adminRoles.includes(role.trim().toLowerCase())) return true;
            if (typeof roles === 'string' && adminRoles.includes(roles.trim().toLowerCase())) return true;
            if (Array.isArray(roles)) {
                return roles.some((r) => {
                    const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
                    return adminRoles.includes(name);
                });
            }
            return false;
        } catch (_) {
            return false;
        }
    };

    const fetchProjects = async () => {
        try {
            setProjectsLoading(true);
            const response = await AuthApi.getProject();
            const projectList = (response && response.data) || response || [];
            if (Array.isArray(projectList)) {
                let activeProjects = projectList.filter(
                    (project) => String(project.deleted) !== "1" && project.deleted !== true && isProjectActive(project.status)
                );

                const isSuperAdmin = isUserSuperAdmin();
                let currentUser = ls.get('user') || ls('user') || {};
                if (typeof currentUser === 'string') {
                    try { currentUser = JSON.parse(currentUser); } catch (_) {}
                }
                if ((!currentUser || typeof currentUser !== 'object') && typeof window !== 'undefined') {
                    const raw = window.localStorage.getItem('user');
                    if (raw) {
                        try { currentUser = JSON.parse(raw); } catch (_) {}
                    }
                }
                const currentUserId = (currentUser && (currentUser.id || currentUser._id || currentUser.user_id)) || null;

                if (!isSuperAdmin) {
                    if (!currentUserId) {
                        activeProjects = [];
                    } else {
                        const uid = Number(currentUserId);
                        activeProjects = activeProjects.filter((p) => {
                            const members = extractIds(p.member_ids);
                            const leads = [
                                ...extractIds(p.lead_ids),
                                ...(p.lead_id ? extractIds(p.lead_id) : [])
                            ];
                            return [...members, ...leads].includes(uid);
                        });
                    }
                }

                setProjects(activeProjects);
                if (initialProject && !taskData.project_name) {
                    setTaskData((prev) => ({ ...prev, project_name: initialProject }));
                }
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
        } finally {
            setProjectsLoading(false);
        }
    };

    const getInitials = (name) => {
        if (!name) return 'U';
        return name
            .split(' ')
            .filter(Boolean)
            .map((part) => part[0].toUpperCase())
            .slice(0, 2)
            .join('');
    };

    const selectedProject = useMemo(() => {
        if (!taskData.project_name) return null;
        return projects.find(
            (p) => String(p.project_name).trim().toLowerCase() === String(taskData.project_name || '').trim().toLowerCase() ||
                   String(p.id) === String(taskData.project_name || '')
        ) || null;
    }, [taskData.project_name, projects]);

    const projectUserIds = useMemo(() => {
        if (!selectedProject) return [];
        const members = extractIds(selectedProject.member_ids || selectedProject.members || selectedProject.developer_id);
        const leads = extractIds(selectedProject.lead_ids || selectedProject.lead_id);
        return Array.from(new Set([...members, ...leads]));
    }, [selectedProject]);

    const availableDevelopers = useMemo(() => {
        if (!taskData.project_name) {
            return [];
        }
        if (projectUserIds.length === 0) {
            return [];
        }
        return developers.filter((dev) => projectUserIds.includes(Number(dev.id)));
    }, [taskData.project_name, projectUserIds, developers]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'project_name') {
            const selectedProj = projects.find(
                (p) => String(p.project_name).trim().toLowerCase() === String(value || '').trim().toLowerCase() ||
                       String(p.id) === String(value || '')
            );
            const projMemberIds = selectedProj
                ? Array.from(new Set([
                    ...extractIds(selectedProj.member_ids || selectedProj.members || selectedProj.developer_id),
                    ...extractIds(selectedProj.lead_ids || selectedProj.lead_id)
                  ]))
                : [];

            setTaskData((prev) => ({
                ...prev,
                project_name: value,
                member_ids: projMemberIds.length > 0
                    ? (prev.member_ids || []).filter((uid) => projMemberIds.includes(Number(uid)))
                    : []
            }));
        } else {
            setTaskData((prev) => ({ ...prev, [name]: value }));
            if (name === 'status' && String(value).trim().toLowerCase() === 'backlog') {
                setSubTasks((prev) => prev.map((st) => ({ ...st, status: 'Backlog' })));
                setNewSubTaskStatus('Backlog');
            }
        }
        if (formErrors[name]) {
            setFormErrors((prev) => ({ ...prev, [name]: '' }));
        }
    };

    // Subtask handlers
    const handleAddSubTask = () => {
        if (editingIndex !== null) {
            return;
        }
        const trimmed = (newSubTaskTitle || '').trim();
        if (!trimmed) {
            return;
        }
        const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
        const rawTl = (newSubTaskTimeline || '').trim();
        const formattedTimeline = rawTl
            ? (rawTl.includes('hr') ? rawTl : `${rawTl} hr`)
            : '';
        setSubTasks((prev) => [
            ...prev,
            {
                name: trimmed,
                status: isBacklogTask ? 'Backlog' : (newSubTaskStatus || 'Pending'),
                details: trimmed,
                timeline: formattedTimeline
            }
        ]);
        setNewSubTaskTitle('');
        setNewSubTaskStatus(isBacklogTask ? 'Backlog' : 'Pending');
        setNewSubTaskTimeline('');
    };

    const handleDeleteSubTask = (index) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this subtask?",
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        }).then((confirm) => {
            if (confirm) {
                setSubTasks((prev) => prev.filter((_, i) => i !== index));
                if (editingIndex === index) {
                    setEditingIndex(null);
                }
            }
        });
    };

    const handleStartEditSubTask = (index) => {
        setEditingIndex(index);
        setEditSubTaskTitle(subTasks[index].name);
        const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
        setEditSubTaskStatus(isBacklogTask ? 'Backlog' : (subTasks[index].status || 'Pending'));
        setEditSubTaskTimeline(subTasks[index].timeline || '');
    };

    const handleSaveEditSubTask = (index) => {
        const trimmed = (editSubTaskTitle || '').trim();
        if (!trimmed) {
            return;
        }
        const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
        const finalStatus = isBacklogTask ? 'Backlog' : (editSubTaskStatus || 'Pending');
        const rawTl = (editSubTaskTimeline || '').trim();
        const formattedTimeline = rawTl
            ? (rawTl.includes('hr') ? rawTl : `${rawTl} hr`)
            : '';
        setSubTasks((prev) =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, name: trimmed, status: finalStatus, details: trimmed, timeline: formattedTimeline }
                    : item
            )
        );
        setEditingIndex(null);
    };

    const handleCancelEditSubTask = () => {
        setEditingIndex(null);
    };

    const validate = (values) => {
        let errors = {};
        if (!values.task || !values.task.trim()) {
            errors.task = 'Task name is required';
        }
        if (!values.project_name) {
            errors.project_name = 'Project name is required';
        } else {
            const chosen = projects.find((p) => p.project_name === values.project_name);
            if (chosen && Number(chosen.status) !== 1) {
                errors.project_name = 'Tasks cannot be added to an inactive project. Please activate the project first.';
            }
        }
        if (!values.member_ids || values.member_ids.length === 0) {
            errors.member_ids = 'Please select at least one user';
        }
        if (values.timeline) {
            const tlCheck = validateTimeline(values.timeline);
            if (!tlCheck.isValid) {
                errors.timeline = tlCheck.error;
            }
        }
        return errors;
    };

    // Format time into DB YYYY-MM-DD HH:mm:ss format (date saved automatically in DB, only time in front)
    const formatToDbDateTime = (timeStr) => {
        if (!timeStr || !timeStr.trim()) return null;
        const trimmed = timeStr.trim();
        const today = moment().format('YYYY-MM-DD');

        // If string already has a date part, parse it directly
        if (trimmed.includes('-') || trimmed.includes('/')) {
            const m = moment(trimmed, [
                'DD/MM/YYYY hh:mm A',
                'DD/MM/YYYY HH:mm',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm',
                'YYYY-MM-DD'
            ]);
            return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : trimmed;
        }

        // Pure time string: HH:mm or HH:mm:ss or hh:mm A
        const m = moment(`${today} ${trimmed}`, [
            'YYYY-MM-DD HH:mm',
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DD hh:mm A',
            'YYYY-MM-DD h:mm A'
        ]);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : `${today} ${trimmed}:00`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }

        const errors = validate(taskData);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }

        setSubmitLoading(true);
        swal({
            title: 'Loading',
            text: 'Please wait...',
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: createSwalLoaderNode()
        });

        try {
            // Compute selected developer names and ids
            const selectedMembers = (taskData.member_ids || []).map((uid) => {
                return developers.find((d) => Number(d.id) === Number(uid));
            }).filter(Boolean);

            const devNames = selectedMembers.map((m) => {
                return m.firstName ? `${m.firstName} ${m.lastName || ''}`.trim() : m.name;
            }).join(', ');

            const primaryDevId = (taskData.member_ids && taskData.member_ids.length > 0)
                ? taskData.member_ids[0]
                : '';
            const startMoment = moment();
            const cleanTimeline = clampAndFormatTimeline(taskData.timeline || '00:00') || '00:00 hr';
            const [th, tm] = cleanTimeline.replace(/[^0-9:]/g, '').split(':').map(Number);
            const totalMins = (isNaN(th) ? 0 : th) * 60 + (isNaN(tm) ? 0 : tm);
            const deliverMoment = moment().add(totalMins, 'minutes');

            // Upload task files to get server URLs
            let uploadedFilesList = [];
            if (taskFiles && taskFiles.length > 0) {
                uploadedFilesList = await Promise.all(
                    taskFiles.map(async (f) => {
                        if (f instanceof File || (f && f.name && !f.url)) {
                            const res = await AuthApi.uploadTaskFile(f);
                            if (res && res.status && res.data) {
                                return res.data;
                            }
                            console.error('File upload failed for', f.name, res);
                            return null;
                        }
                        return (f && (f.url || f.name)) ? f : null;
                    })
                );
                uploadedFilesList = uploadedFilesList.filter(Boolean);
            }

            const formattedTimeline = cleanTimeline
                ? (cleanTimeline.includes('hr') ? cleanTimeline : `${cleanTimeline} hr`)
                : '';

            const isBacklogTask = String(taskData.status || '').trim().toLowerCase() === 'backlog';
            const taskPayload = {
                task: taskData.task.trim(),
                project_name: taskData.project_name,
                developer_name: devNames,
                developer_user_id: primaryDevId,
                developer_user_ids: taskData.member_ids,
                member_ids: taskData.member_ids,
                status: taskData.status || 'Pending',
                priority: taskData.priority || 'Medium',
                timeline: formattedTimeline || cleanTimeline,
                duration: formattedTimeline || cleanTimeline,
                task_date_time: startMoment.format('YYYY-MM-DD HH:mm:ss'),
                task_deliver_date: deliverMoment.format('YYYY-MM-DD HH:mm:ss'),
                description: (taskData.description || '').trim(),
                files: uploadedFilesList,
                subTasks: subTasks.map((st, idx) => {
                    const rawTl = (st.timeline || '').trim();
                    const tl = rawTl ? (rawTl.includes('hr') ? rawTl : `${rawTl} hr`) : '';
                    return {
                        id: idx + 1,
                        name: st.name.trim(),
                        status: isBacklogTask ? 'Backlog' : (st.status || 'Pending'),
                        details: st.details || st.name.trim(),
                        timeline: tl
                    };
                }),
                sub_tasks: subTasks.map((st, idx) => {
                    const rawTl = (st.timeline || '').trim();
                    const tl = rawTl ? (rawTl.includes('hr') ? rawTl : `${rawTl} hr`) : '';
                    return {
                        id: idx + 1,
                        name: st.name.trim(),
                        status: isBacklogTask ? 'Backlog' : (st.status || 'Pending'),
                        details: st.details || st.name.trim(),
                        timeline: tl
                    };
                })
            };

            const response = await AuthApi.createTask(taskPayload);
            swal.close();

            if (response && (response.status || response.success)) {
                if (typeof AuthApi.invalidateCache === 'function') {
                    AuthApi.invalidateCache('getTasks');
                }
                swal('Success', 'Task created successfully!', 'success');
                props.history.push('/tasks');
            } else {
                let errorMsg = 'Failed to create task.';
                if (response) {
                    if (response.error && typeof response.error === 'object') {
                        const errorList = Object.values(response.error).flat().filter(Boolean);
                        if (errorList.length > 0) {
                            errorMsg = errorList.join('\n');
                        } else if (response.message) {
                            errorMsg = response.message;
                        }
                    } else if (response.message) {
                        errorMsg = response.message;
                    }
                }
                swal('Error', errorMsg, 'error');
            }
        } catch (error) {
            swal.close();
            console.error('Error creating task:', error);
            swal('Error', 'An unexpected error occurred while creating task.', 'error');
        } finally {
            setSubmitLoading(false);
        }
    };

    // pageLoading removed — form renders immediately; data loads in background
    const isTaskBacklog = String(taskData.status || '').trim().toLowerCase() === 'backlog';

    const pageContent = (
        <div style={{ marginBottom: '11%' }}>
            {/* Breadcrumb Card */}
            <div className="holiday-breadcrumb-card">
                <Breadcrumb
                    {...props}
                    primaryPageName="Tasks"
                    primaryPageLink="/tasks"
                    isSecondaryPage={true}
                    secondaryPageName="Add Task"
                />
            </div>

            {/* Form Card */}
            <div className="holiday-form-card">
                <Typography
                    variant="h2"
                    className="holiday-form-title"
                    style={{
                        color: '#036dda',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        marginBottom: '24px'
                    }}
                >
                    Add Task
                </Typography>

                <form className="common-form-fields" onSubmit={handleSubmit} noValidate>
                    <Grid container spacing={4}>
                        {/* Task Name */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Task name"
                                placeholder="Enter task name..."
                                name="task"
                                value={taskData.task}
                                onChange={handleChange}
                                error={Boolean(formErrors.task)}
                                helperText={formErrors.task}
                                required
                            />
                        </Grid>

                        {/* Project Name */}
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined" error={Boolean(formErrors.project_name)}>
                                <InputLabel shrink id="create-task-project-label">Project Name *</InputLabel>
                                <Select
                                    labelId="create-task-project-label"
                                    id="create-task-project"
                                    name="project_name"
                                    value={taskData.project_name}
                                    onChange={handleChange}
                                    label="Project Name *"
                                    notched={true}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (projectsLoading) {
                                            return (
                                                <span style={{ color: '#94a3b8', display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <CircularProgress size={14} style={{ color: '#036dda' }} />
                                                    Loading projects...
                                                </span>
                                            );
                                        }
                                        if (!selected) {
                                            return (
                                                <span style={{ color: '#94a3b8' }}>
                                                    {projects.length === 0 ? 'No project available' : 'Select Project'}
                                                </span>
                                            );
                                        }
                                        return selected;
                                    }}
                                    MenuProps={{ disableScrollLock: true }}
                                >
                                    {projectsLoading ? (
                                        <MenuItem value="" disabled style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                            Loading projects...
                                        </MenuItem>
                                    ) : projects.length === 0 ? (
                                        <MenuItem value="" disabled style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                            No project available
                                        </MenuItem>
                                    ) : (
                                        [
                                            <MenuItem key="empty-select" value="" disabled style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                                Select Project
                                            </MenuItem>,
                                            ...projects.map((project) => (
                                                <MenuItem key={project.id} value={project.project_name}>
                                                    {project.project_name}
                                                </MenuItem>
                                            ))
                                        ]
                                    )}
                                </Select>
                                {formErrors.project_name && (
                                    <FormHelperText error>{formErrors.project_name}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Select User (Multiple Select) - Attendance Style Popover */}
                        <Grid item xs={12} sm={6}>
                            <div style={{ position: 'relative' }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Select User"
                                    placeholder={(taskData.member_ids || []).length === 0 ? "Select User" : undefined}
                                    value=""
                                    required
                                    onClick={(e) => !usersLoading && setUserPopoverAnchor(e.currentTarget)}
                                    error={Boolean(formErrors.member_ids)}
                                    helperText={formErrors.member_ids}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            cursor: usersLoading ? 'wait' : 'pointer',
                                            padding: '0 14px',
                                            height: '56px',
                                            minHeight: '56px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        startAdornment: (taskData.member_ids || []).length > 0 ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: 'calc(100% - 24px)',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                 <span className="tm-selected-users-text">
                                                    {taskData.member_ids.length} user(s) selected
                                                </span>

                                                <div
                                                    ref={avatarsScrollRef}
                                                    className="tm-avatars-scroll"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        overflowX: 'auto',
                                                        overflowY: 'hidden',
                                                        maxWidth: '100%',
                                                        padding: '4px 24px 4px 6px',
                                                        flex: 1,
                                                        marginRight: 8
                                                    }}
                                                >
                                                    {taskData.member_ids.map((uid) => {
                                                        const u = developers.find((d) => Number(d.id) === Number(uid));
                                                        const name = u
                                                            ? (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name)
                                                            : `User #${uid}`;
                                                        return (
                                                            <Tooltip key={uid} title={name} arrow>
                                                                <Avatar
                                                                    src={(u && u.photo && String(u.photo).trim() !== '') ? resolveImageUrl(u.photo) : defaultAvatar}
                                                                    imgProps={{
                                                                        onError: (e) => {
                                                                            if (e.target.src !== defaultAvatar) {
                                                                                e.target.src = defaultAvatar;
                                                                            }
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: 36,
                                                                        height: 36,
                                                                        flexShrink: 0,
                                                                        backgroundColor: 'transparent',
                                                                        border: '2px solid #ffffff',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.18)'
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        );
                                                    })}
                                                    <div style={{ minWidth: 20, width: 20, flexShrink: 0, height: 1 }} />
                                                </div>
                                            </div>
                                        ) : (
                                            <span className="tm-select-user-placeholder">
                                                Select User
                                            </span>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end" style={{ marginLeft: 'auto' }}>
                                                {usersLoading
                                                    ? <CircularProgress size={18} style={{ color: '#036dda' }} />
                                                    : <ExpandMoreIcon style={{ cursor: 'pointer', color: '#666' }} />
                                                }
                                            </InputAdornment>
                                        ),
                                        inputProps: {
                                            readOnly: true,
                                            style: {
                                                display: 'none'
                                            }
                                        }
                                    }}
                                />

                                <Popover
                                    open={Boolean(userPopoverAnchor)}
                                    anchorEl={userPopoverAnchor}
                                    onClose={() => {
                                        setUserPopoverAnchor(null);
                                        setUserSearchQuery('');
                                    }}
                                    disableScrollLock
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    PaperProps={{
                                        className: 'attendance-user-popover-paper',
                                        style: {
                                            width: 300,
                                            marginTop: 5,
                                            borderRadius: 8,
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                            backgroundColor: '#ffffff'
                                        }
                                    }}
                                >
                                    <Box p={1.5} className="attendance-user-popover-header">
                                        <Typography
                                            variant="subtitle2"
                                            className="attendance-user-popover-title"
                                            style={{
                                                fontWeight: 700,
                                                marginBottom: 8,
                                                color: '#ffffff'
                                            }}
                                        >
                                            Select User
                                        </Typography>
                                        <TextField
                                            className="common-user-search-field"
                                            fullWidth
                                            size="small"
                                            placeholder="Search users..."
                                            variant="outlined"
                                            value={userSearchQuery}
                                            onChange={(e) => setUserSearchQuery(e.target.value)}
                                            InputProps={{
                                                style: {
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: '4px',
                                                    height: '36px'
                                                },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon fontSize="small" style={{ color: '#036dda' }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                    <Divider />
                                    <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                        <MenuItem
                                            className="attendance-user-option"
                                            disabled={availableDevelopers.length === 0}
                                            selected={availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))}
                                            onClick={() => {
                                                if (availableDevelopers.length === 0) return;
                                                const allIds = availableDevelopers.map((d) => Number(d.id));
                                                const isAllSelected = allIds.length > 0 && allIds.every((id) => (taskData.member_ids || []).map(Number).includes(id));
                                                const nextIds = isAllSelected ? [] : allIds;
                                                setTaskData((prev) => ({
                                                    ...prev,
                                                    member_ids: nextIds
                                                }));
                                                if (nextIds.length > 0 && formErrors.member_ids) {
                                                    setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                                                }
                                            }}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#036dda' : undefined,
                                                color: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#ffffff' : undefined,
                                            }}
                                        >
                                            <ListItemText
                                                primary="All Users"
                                                primaryTypographyProps={{
                                                    style: {
                                                        color: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? '#ffffff' : 'inherit',
                                                        fontWeight: (availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id)))) ? 600 : 400,
                                                    }
                                                }}
                                            />
                                            {availableDevelopers.length > 0 && availableDevelopers.every((d) => (taskData.member_ids || []).map(Number).includes(Number(d.id))) && (
                                                <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />
                                            )}
                                        </MenuItem>
                                        {availableDevelopers
                                            .filter((dev) => {
                                                const q = (userSearchQuery || '').toLowerCase();
                                                const name = (dev.firstName ? `${dev.firstName} ${dev.lastName || ''}` : dev.name || '').toLowerCase();
                                                return name.includes(q);
                                            })
                                            .map((dev) => {
                                                const devDisplayName = dev.firstName
                                                    ? `${dev.firstName} ${dev.lastName || ''}`.trim()
                                                    : dev.name;
                                                const isChecked = (taskData.member_ids || []).map(Number).includes(Number(dev.id));
                                                return (
                                                    <MenuItem
                                                        key={dev.id}
                                                        className={`attendance-user-option ${isChecked ? 'attendance-user-selected' : ''}`}
                                                        selected={isChecked}
                                                        onClick={() => {
                                                            const current = (taskData.member_ids || []).map(Number);
                                                            const updated = isChecked
                                                                ? current.filter((id) => id !== Number(dev.id))
                                                                : [...current, Number(dev.id)];
                                                            setTaskData((prev) => ({
                                                                ...prev,
                                                                member_ids: updated
                                                            }));
                                                            if (updated.length > 0 && formErrors.member_ids) {
                                                                setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                                                            }
                                                        }}
                                                        style={{
                                                            padding: '8px 16px',
                                                            backgroundColor: isChecked ? '#036dda' : undefined,
                                                            color: isChecked ? '#ffffff' : undefined,
                                                        }}
                                                    >
                                                        <Box display="flex" alignItems="center" width="100%">
                                                            <Avatar
                                                                src={(dev && dev.photo && String(dev.photo).trim() !== '') ? resolveImageUrl(dev.photo) : defaultAvatar}
                                                                imgProps={{
                                                                    onError: (e) => {
                                                                        if (e.target.src !== defaultAvatar) {
                                                                            e.target.src = defaultAvatar;
                                                                        }
                                                                    }
                                                                }}
                                                                style={{
                                                                    width: 32,
                                                                    height: 32,
                                                                    marginRight: 12,
                                                                    border: isChecked ? '2px solid #ffffff' : 'none',
                                                                    backgroundColor: 'transparent'
                                                                }}
                                                            />
                                                            <ListItemText
                                                                primary={devDisplayName}
                                                                primaryTypographyProps={{
                                                                    style: {
                                                                        color: isChecked ? '#ffffff' : 'inherit',
                                                                        fontWeight: isChecked ? 600 : 400,
                                                                    }
                                                                }}
                                                            />
                                                            {isChecked && (
                                                                <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem', marginLeft: 'auto' }} />
                                                            )}
                                                        </Box>
                                                    </MenuItem>
                                                );
                                            })}
                                        {availableDevelopers.length === 0 && (
                                            <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                                                {!taskData.project_name ? 'Please select a project first' : 'No users assigned to this project'}
                                            </div>
                                        )}
                                    </div>
                                </Popover>
                            </div>
                        </Grid>

                        {/* Priority */}
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="create-task-priority-label">Priority</InputLabel>
                                <Select
                                    labelId="create-task-priority-label"
                                    id="create-task-priority"
                                    name="priority"
                                    value={taskData.priority || 'Medium'}
                                    onChange={handleChange}
                                    label="Priority"
                                    MenuProps={{ disableScrollLock: true }}
                                >
                                    <MenuItem value="Low">Low</MenuItem>
                                    <MenuItem value="Medium">Medium</MenuItem>
                                    <MenuItem value="High">High</MenuItem>
                                    <MenuItem value="Urgent">Urgent</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Status */}
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="create-task-status-label">Status</InputLabel>
                                <Select
                                    labelId="create-task-status-label"
                                    id="create-task-status"
                                    name="status"
                                    value={taskData.status || 'Pending'}
                                    onChange={handleChange}
                                    label="Status"
                                    MenuProps={{ disableScrollLock: true }}
                                >
                                    <MenuItem value="Backlog">Backlog</MenuItem>
                                    <MenuItem value="Pending">To Do / Pending</MenuItem>
                                    <MenuItem value="In Progress">In Progress</MenuItem>
                                    <MenuItem value="Testing">Testing / Review</MenuItem>
                                    <MenuItem value="Done">Done</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Add time line (Max 8 hours, 00:00 format, manual typing) */}
                        <Grid item xs={12} sm={6}>
                            <TimelineInputField
                                label="Add time line"
                                placeholder="00:00"
                                name="timeline"
                                id="task_timeline"
                                value={taskData.timeline || ''}
                                onChange={(val) => {
                                    setTaskData((prev) => ({ ...prev, timeline: val }));
                                    if (formErrors.timeline) {
                                        setFormErrors((prev) => ({ ...prev, timeline: '' }));
                                    }
                                }}
                                error={Boolean(formErrors.timeline)}
                                helperText={formErrors.timeline}
                            />
                        </Grid>

                        {/* Files & Photos Upload (Optional) */}
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                ref={fileInputRef}
                                id="task-files-input"
                                multiple
                                accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                                style={{ display: 'none' }}
                                onChange={handleFileSelect}
                            />
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Upload Files & Photos"
                                value={taskFiles.length > 0 ? `${taskFiles.length} file${taskFiles.length > 1 ? 's' : ''} selected` : ''}
                                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                inputProps={{
                                    readOnly: true,
                                    style: {
                                        cursor: 'pointer',
                                        textOverflow: 'ellipsis'
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Upload file (Images, Docs, PDF, Word)" arrow placement="top">
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        fileInputRef.current && fileInputRef.current.click();
                                                    }}
                                                    className="tm-desc-upload-btn"
                                                    aria-label="Upload file"
                                                >
                                                    <TrayUploadIcon size={21} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {/* Selected Files List */}
                            {taskFiles.length > 0 && (
                                <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 180, overflowY: 'auto' }}>
                                    {taskFiles.map((file, idx) => {
                                        const isImg = file.type ? file.type.startsWith('image/') : false;
                                        const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
                                        const isWord = file.name.toLowerCase().endsWith('.doc') || file.name.toLowerCase().endsWith('.docx');
                                        return (
                                            <div key={idx} className="tm-selected-file-item">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden', minWidth: 0 }}>
                                                    {isImg ? (
                                                        <ImageIcon style={{ color: '#0284c7', fontSize: 18, flexShrink: 0 }} />
                                                    ) : isPdf ? (
                                                        <PictureAsPdfIcon style={{ color: '#ef4444', fontSize: 18, flexShrink: 0 }} />
                                                    ) : isWord ? (
                                                        <DescriptionIcon style={{ color: '#2563eb', fontSize: 18, flexShrink: 0 }} />
                                                    ) : (
                                                        <InsertDriveFileIcon style={{ color: '#64748b', fontSize: 18, flexShrink: 0 }} />
                                                    )}
                                                    <span
                                                        style={{
                                                            fontWeight: 500,
                                                            color: 'var(--tm-text)',
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            fontSize: 12
                                                        }}
                                                        title={file.name}
                                                    >
                                                        {file.name}
                                                    </span>
                                                    <span style={{ fontSize: 10, color: '#64748b', flexShrink: 0 }}>
                                                        ({(file.size / 1024).toFixed(0)}KB)
                                                    </span>
                                                </div>
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveFile(idx);
                                                    }}
                                                    style={{ color: '#94a3b8', padding: 2, marginLeft: 4, flexShrink: 0 }}
                                                    title="Remove file"
                                                >
                                                    <CloseIcon style={{ fontSize: 16 }} />
                                                </IconButton>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </Grid>

                        {/* Description (Material-UI Outlined TextField with Wysiwyg Rich Formatting) */}
                        <Grid item xs={12}>
                            <WysiwygDescriptionEditor
                                label="Description"
                                placeholder="Enter task description..."
                                name="description"
                                id="task_description"
                                value={taskData.description || ''}
                                onChange={(html) => {
                                    setTaskData((prev) => ({ ...prev, description: html }));
                                    if (formErrors.description) {
                                        setFormErrors((prev) => ({ ...prev, description: '' }));
                                    }
                                }}
                                error={Boolean(formErrors.description)}
                                helperText={formErrors.description}
                                rows={4}
                            />
                        </Grid>

                        {/* Sub Tasks Accordion (Collapsible dropdown like Add User Other Settings) */}
                        <Grid item xs={12}>
                            <div style={{ width: '100%', border: '1px solid rgba(0, 0, 0, .125)', borderRadius: 4 }}>
                                <Accordion elevation={0} style={{ background: 'transparent' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon style={{ color: '#036dda' }} />}
                                        aria-controls="subtask-accordion-content"
                                        id="subtask-accordion-header"
                                        style={{ color: '#036dda', minHeight: 48 }}
                                    >
                                        <Typography
                                            className="common-form-page-title"
                                            style={{
                                                color: 'var(--hrms-primary-blue-end, #036dda)',
                                                fontSize: 15,
                                                fontWeight: 400
                                            }}
                                        >
                                            Add Sub Task
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: 'block', padding: '12px 16px 20px 16px' }}>
                                        {/* Quick Add Bar */}
                                        <div
                                            className="tm-subtask-add-bar"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: 12,
                                                opacity: editingIndex !== null ? 0.6 : 1,
                                                transition: 'opacity 0.2s ease'
                                            }}
                                        >
                                            <TextField
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                label="Sub Task Title"
                                                placeholder={
                                                    editingIndex !== null
                                                        ? 'Finish or cancel editing below first...'
                                                        : 'Type subtask title and press Enter...'
                                                }
                                                value={newSubTaskTitle}
                                                onChange={(e) => setNewSubTaskTitle(e.target.value)}
                                                disabled={editingIndex !== null}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleAddSubTask();
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        fontWeight: 400,
                                                        fontSize: 14
                                                    }
                                                }}
                                            />
                                            <Tooltip
                                                title={
                                                    isTaskBacklog
                                                        ? "Main task is in Backlog, so subtask status is locked to Backlog"
                                                        : ""
                                                }
                                                arrow
                                                placement="top"
                                            >
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={editingIndex !== null}
                                                    style={{ minWidth: 160 }}
                                                >
                                                    <InputLabel id="new-subtask-status-label">
                                                        {isTaskBacklog ? 'Status (Locked)' : 'Status'}
                                                    </InputLabel>
                                                    <Select
                                                        labelId="new-subtask-status-label"
                                                        value={isTaskBacklog ? 'Backlog' : newSubTaskStatus}
                                                        onChange={(e) => {
                                                            if (!isTaskBacklog) {
                                                                setNewSubTaskStatus(e.target.value);
                                                            }
                                                        }}
                                                        label={isTaskBacklog ? 'Status (Locked)' : 'Status'}
                                                        MenuProps={{ disableScrollLock: true }}
                                                    >
                                                        <MenuItem value="Backlog">Backlog</MenuItem>
                                                        {isTaskBacklog ? (
                                                            <MenuItem
                                                                disabled
                                                                value=""
                                                                style={{
                                                                    fontSize: 12,
                                                                    color: '#64748b',
                                                                    fontStyle: 'italic',
                                                                    borderTop: '1px solid #f1f5f9',
                                                                    marginTop: 4,
                                                                    paddingTop: 8,
                                                                    cursor: 'default',
                                                                    whiteSpace: 'normal',
                                                                    lineHeight: 1.3
                                                                }}
                                                            >
                                                                ℹ️ Main task is Backlog (Locked)
                                                            </MenuItem>
                                                        ) : (
                                                            [
                                                                <MenuItem key="Pending" value="Pending">Pending</MenuItem>,
                                                                <MenuItem key="In Progress" value="In Progress">In Progress</MenuItem>,
                                                                <MenuItem key="Testing" value="Testing">Testing</MenuItem>,
                                                                <MenuItem key="Done" value="Done">Done</MenuItem>
                                                            ]
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Tooltip>
                                            <div style={{ width: 140, minWidth: 120 }}>
                                                <TimelineInputField
                                                    size="small"
                                                    label="Timeline"
                                                    placeholder="00:00"
                                                    value={newSubTaskTimeline}
                                                    onChange={(val) => setNewSubTaskTimeline(val)}
                                                    disabled={editingIndex !== null}
                                                />
                                            </div>
                                            <Button
                                                type="button"
                                                variant="contained"
                                                disabled={editingIndex !== null}
                                                onClick={handleAddSubTask}
                                                style={{
                                                    backgroundColor: editingIndex !== null ? '#94a3b8' : '#036dda',
                                                    color: '#ffffff',
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                    height: 40,
                                                    minWidth: 120,
                                                    padding: '0 20px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    textAlign: 'center',
                                                    lineHeight: 1,
                                                    whiteSpace: 'nowrap',
                                                    boxShadow: 'none',
                                                    cursor: editingIndex !== null ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                Add Subtask
                                            </Button>
                                        </div>

                                        {/* Subtasks List */}
                                        {subTasks.length > 0 ? (
                                            <div className="tm-subtask-list">
                                                {subTasks.map((sub, index) => {
                                                    const isEditing = editingIndex === index;
                                                    const statusClass = `tm-subtask-status-${(sub.status || 'pending').toLowerCase().replace(/\s+/g, '')}`;

                                                    if (isEditing) {
                                                        // INLINE EDIT MODE
                                                        return (
                                                            <div key={index} className="tm-subtask-row tm-subtask-row-edit" style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="outlined"
                                                                    label="Sub Task Title"
                                                                    value={editSubTaskTitle}
                                                                    onChange={(e) => setEditSubTaskTitle(e.target.value)}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            handleSaveEditSubTask(index);
                                                                        }
                                                                    }}
                                                                    style={{ background: '#ffffff', borderRadius: 4 }}
                                                                    inputProps={{
                                                                        style: {
                                                                            fontWeight: 400,
                                                                            fontSize: 14
                                                                        }
                                                                    }}
                                                                />
                                                                <Tooltip
                                                                    title={
                                                                        isTaskBacklog
                                                                            ? "Main task is in Backlog, so subtask status is locked to Backlog"
                                                                            : ""
                                                                    }
                                                                    arrow
                                                                    placement="top"
                                                                >
                                                                    <FormControl variant="outlined" size="small" style={{ minWidth: 160, background: '#ffffff', borderRadius: 4 }}>
                                                                        <InputLabel id={`edit-subtask-status-${index}`}>
                                                                            {isTaskBacklog ? 'Status (Locked)' : 'Status'}
                                                                        </InputLabel>
                                                                        <Select
                                                                            labelId={`edit-subtask-status-${index}`}
                                                                            value={isTaskBacklog ? 'Backlog' : editSubTaskStatus}
                                                                            onChange={(e) => {
                                                                                if (!isTaskBacklog) {
                                                                                    setEditSubTaskStatus(e.target.value);
                                                                                }
                                                                            }}
                                                                            label={isTaskBacklog ? 'Status (Locked)' : 'Status'}
                                                                            MenuProps={{ disableScrollLock: true }}
                                                                        >
                                                                            <MenuItem value="Backlog">Backlog</MenuItem>
                                                                            {isTaskBacklog ? (
                                                                                <MenuItem
                                                                                    disabled
                                                                                    value=""
                                                                                    style={{
                                                                                        fontSize: 12,
                                                                                        color: '#64748b',
                                                                                        fontStyle: 'italic',
                                                                                        borderTop: '1px solid #f1f5f9',
                                                                                        marginTop: 4,
                                                                                        paddingTop: 8,
                                                                                        cursor: 'default',
                                                                                        whiteSpace: 'normal',
                                                                                        lineHeight: 1.3
                                                                                    }}
                                                                                >
                                                                                    ℹ️ Main task is Backlog (Locked)
                                                                                </MenuItem>
                                                                            ) : (
                                                                                [
                                                                                    <MenuItem key="Pending" value="Pending">Pending</MenuItem>,
                                                                                    <MenuItem key="In Progress" value="In Progress">In Progress</MenuItem>,
                                                                                    <MenuItem key="Testing" value="Testing">Testing</MenuItem>,
                                                                                    <MenuItem key="Done" value="Done">Done</MenuItem>
                                                                                ]
                                                                            )}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Tooltip>
                                                                <div style={{ width: 140, minWidth: 120 }}>
                                                                    <TimelineInputField
                                                                        size="small"
                                                                        label="Timeline"
                                                                        placeholder="00:00"
                                                                        value={editSubTaskTimeline}
                                                                        onChange={(val) => setEditSubTaskTimeline(val)}
                                                                    />
                                                                </div>
                                                                <div className="tm-subtask-actions" style={{ gap: 8 }}>
                                                                    <Button
                                                                        type="button"
                                                                        size="small"
                                                                        variant="contained"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            handleSaveEditSubTask(index);
                                                                        }}
                                                                        style={{
                                                                            backgroundColor: '#036dda',
                                                                            color: '#ffffff',
                                                                            textTransform: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 13,
                                                                            height: 38,
                                                                            minWidth: 80,
                                                                            padding: '0 18px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            textAlign: 'center',
                                                                            lineHeight: 1,
                                                                            boxShadow: 'none'
                                                                        }}
                                                                    >
                                                                        Update
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            handleCancelEditSubTask();
                                                                        }}
                                                                        style={{
                                                                            backgroundColor: '#f1f5f9',
                                                                            color: '#475569',
                                                                            textTransform: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 13,
                                                                            height: 38,
                                                                            minWidth: 80,
                                                                            padding: '0 18px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            textAlign: 'center',
                                                                            lineHeight: 1
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        );
                                                    }

                                                    // NORMAL VIEW MODE
                                                    return (
                                                        <div key={index} className="tm-subtask-row">
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
                                                                <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--tm-text, #1e293b)' }}>
                                                                    {sub.name}
                                                                </span>
                                                            </div>

                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                                {sub.timeline && (
                                                                    <span
                                                                        className="tm-subtask-timeline-pill"
                                                                        style={{
                                                                            fontSize: 12,
                                                                            fontWeight: 600,
                                                                            color: '#036dda',
                                                                            background: 'rgba(3, 109, 218, 0.08)',
                                                                            border: '1px solid rgba(3, 109, 218, 0.2)',
                                                                            borderRadius: 12,
                                                                            padding: '2px 8px',
                                                                            whiteSpace: 'nowrap'
                                                                        }}
                                                                    >
                                                                        ⏱️ {sub.timeline.includes('hr') ? sub.timeline : `${sub.timeline} hr`}
                                                                    </span>
                                                                )}
                                                                <span className={`tm-subtask-status-pill ${statusClass}`}>
                                                                    {sub.status || 'Pending'}
                                                                </span>

                                                                <div className="tm-subtask-actions">
                                                                    <Tooltip title="Edit Subtask">
                                                                        <IconButton
                                                                            type="button"
                                                                            size="small"
                                                                            className="common-action-icon"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleStartEditSubTask(index);
                                                                            }}
                                                                            style={{ padding: 6 }}
                                                                        >
                                                                            <FontAwesomeIconComponent
                                                                                classes="fa fa-edit"
                                                                                colorName="primary"
                                                                                fontSize="small"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Delete Subtask">
                                                                        <IconButton
                                                                            type="button"
                                                                            size="small"
                                                                            className="common-action-icon"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleDeleteSubTask(index);
                                                                            }}
                                                                            style={{ padding: 6 }}
                                                                        >
                                                                            <FontAwesomeIconComponent
                                                                                classes="fa fa-trash"
                                                                                colorName="primary"
                                                                                fontSize="small"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="tm-subtask-empty">
                                                No subtasks added yet. Type a title above and click "Add Subtask".
                                            </div>
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', marginTop: '16px' }}>
                            <Button
                                type="submit"
                                className="btn-success"
                                style={{ marginTop: '10px', textTransform: 'none' }}
                                variant="contained"
                                color="primary"
                                disabled={submitLoading}
                            >
                                {submitLoading ? (
                                    <>
                                        <CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} />
                                        Saving...
                                    </>
                                ) : (
                                    'Save'
                                )}
                            </Button>
                            <Button
                                type="button"
                                className="btn-cancel"
                                style={{ marginTop: '10px', textTransform: 'none' }}
                                disabled={submitLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.history.push('/tasks');
                                }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </div>
    );

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                setAutUser={props.setAutUser}
                component={pageContent}
            />
            <Footer />
        </div>
    );
};

export default CreateTask;
